import { connect } from 'react-redux';
import UserInfo from './UserInfo';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  user: state.session.user,
  selectedEmployer: state.session.selectedEmployer
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInfo);



// WEBPACK FOOTER //
// ./src/containers/UserInfo/index.js